import {
  Document,
  ExternalHyperlink,
  HeadingLevel,
  Packer,
  PageBreak,
  Paragraph,
  TextRun,
} from 'docx/build/index.js'

function inlineRuns(node, formatting = {}) {
  const runs = []
  node.childNodes.forEach(child => {
    if (child.nodeType === Node.TEXT_NODE) {
      if (child.textContent) runs.push(new TextRun({ text: child.textContent, ...formatting }))
      return
    }
    if (child.nodeType !== Node.ELEMENT_NODE) return
    const tag = child.tagName.toLowerCase()
    if (tag === 'br') {
      runs.push(new TextRun({ text: '', break: 1 }))
      return
    }
    runs.push(...inlineRuns(child, {
      ...formatting,
      bold: formatting.bold || tag === 'strong' || tag === 'b',
      italics: formatting.italics || tag === 'em' || tag === 'i',
      underline: formatting.underline || tag === 'u' ? {} : undefined,
    }))
  })
  return runs
}

function htmlParagraphs(html) {
  if (!html) return [new Paragraph({ children: [new TextRun('')] })]
  const parsed = new DOMParser().parseFromString(html, 'text/html')
  const blocks = Array.from(parsed.body.children)
  if (blocks.length === 0) return [new Paragraph({ children: inlineRuns(parsed.body) })]

  const paragraphs = []
  blocks.forEach(block => {
    const tag = block.tagName.toLowerCase()
    if (tag === 'ul' || tag === 'ol') {
      Array.from(block.children).forEach(item => {
        paragraphs.push(new Paragraph({
          children: inlineRuns(item),
          bullet: { level: 0 },
          spacing: { after: 80 },
        }))
      })
      return
    }
    paragraphs.push(new Paragraph({
      children: inlineRuns(block),
      spacing: { after: 120 },
    }))
  })
  return paragraphs
}

function plainText(html) {
  if (!html) return ''
  return new DOMParser().parseFromString(html, 'text/html').body.textContent || ''
}

export async function buildTextReviewDocx(review) {
  const children = []
  review.forEach((entry, artworkIndex) => {
    const artwork = entry.artwork
    if (artworkIndex > 0) children.push(new Paragraph({ children: [new PageBreak()] }))
    children.push(new Paragraph({
      heading: HeadingLevel.HEADING_1,
      text: artwork.full_name || artwork.name || artwork.artist_name || 'Unknown artist',
    }))
    children.push(new Paragraph({
      heading: HeadingLevel.HEADING_2,
      text: `${plainText(artwork.title) || 'Untitled'}${artwork.accession_number ? ` — ${artwork.accession_number}` : ''}`,
    }))
    children.push(new Paragraph({
      children: [new TextRun({ text: entry.status, bold: true, color: entry.status === 'Public text selected' ? '237A3B' : 'B54708' })],
      spacing: { after: 240 },
    }))

    if (entry.texts.length === 0) {
      children.push(new Paragraph({ children: [new TextRun({ text: 'No text', bold: true })] }))
      return
    }

    entry.texts.forEach(text => {
      children.push(new Paragraph({
        heading: HeadingLevel.HEADING_3,
        text: `${text.given_filename || text.title || 'Untitled text'}${text.isPublic ? ' — PUBLIC' : ''}`,
      }))
      children.push(...htmlParagraphs(text.content))
      children.push(new Paragraph({
        children: [new ExternalHyperlink({
          link: text.editUrl,
          children: [new TextRun({ text: 'Edit this text in CMS', style: 'Hyperlink' })],
        })],
        spacing: { after: 300 },
      }))
    })
  })

  const document = new Document({ sections: [{ children }] })
  return Packer.toBlob(document)
}



// WEBPACK FOOTER //
// ./src/utils/textReviewDocx.js